import React, { useState } from "react";
import headerlogo from "../../utils/images/header-logo.svg";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import { config } from "../../config"
import { toast } from "react-toastify";

function Header() {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const [inquiry, setInquiry] = useState({
        full_name: "",
        email: "",
        phone_number: "",
        // solicitor_type: "solo",
        firm_name: "",
        user_count: "2-5",
        current_software: "",
        game_changing_feature: "",
        demo_access_opt_in: "false",
        refer_colleague: "",
        colleague_email: "",
    });

    const [errors, setErrors] = useState({});


    const validate = () => {
        const newErrors = {};

        if (!inquiry.full_name.trim()) {
            newErrors.full_name = "Full name is required";
        }

        if (!inquiry.email.trim()) {
            newErrors.email = "Email is required";
        } else if (/[A-Z]/.test(inquiry.email)) {
            newErrors.email = "Email must not contain capital letters";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inquiry.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!inquiry.phone_number.trim()) {
            newErrors.phone_number = "Phone number is required";
        } else if (!/^\d{11}$/.test(inquiry.phone_number)) {
            newErrors.phone_number = "Phone number must be 11 numbers";
        }

        // if (inquiry.solicitor_type === "firm" && !inquiry.firm_name.trim()) {
        //     newErrors.firm_name = "Firm name is required";
        // }


        if (!inquiry.game_changing_feature.trim()) {
            newErrors.game_changing_feature = "This field is required";
        }

        if (inquiry.refer_colleague && !inquiry.colleague_email.trim()) {
            newErrors.colleague_email = "Colleague email is required";
        } else if (
            inquiry.refer_colleague &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inquiry.colleague_email)
        ) {
            newErrors.colleague_email = "Invalid colleague email format";
        }



        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        console.log(inquiry);

        try {
            const response = await fetch(`${config.localApiUrl}/api/createInquiry`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(inquiry)
            });
            const result = await response.json();
            if (result.Status === 200) {
                toast.success(result.Message);
                setInquiry({
                    full_name: "",
                    email: "",
                    phone_number: "",
                    // solicitor_type: "solo",
                    firm_name: "",
                    user_count: "2-5",
                    current_software: "",
                    game_changing_feature: "",
                    demo_access_opt_in: "false",
                    refer_colleague: "",
                    colleague_email: "",
                });
                handleClose();
            } else {
                toast.error(result.Message);
            }
        } catch (error) {
            console.log("Failed to create Data:", error.Message);
            toast.error("Failed to create Data.");
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === "phone_number") {
            const cleanedValue = value.replace(/\D/g, "");
            const formattedValue = cleanedValue.slice(0, 11);
            setInquiry({ ...inquiry, phone_number: formattedValue });
        } else if (name === "refer_colleague") {
            setInquiry({
                ...inquiry,
                refer_colleague: checked,
                colleague_email: checked ? inquiry.colleague_email : ""
            });
        } else {
            setInquiry({ ...inquiry, [name]: type === 'checkbox' ? checked : value });
        }
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    return (
        <>
            <div className="header-area fixed-tab">
                <div className="container">
                    <div className="header-row">
                        <div className="logo">
                            <a href="/">
                                <img src={headerlogo} alt="logo" />
                            </a>
                        </div>
                        <div className="get-started">
                            <button title="Get Started" onClick={handleShow} class="primary-btn sm">Get Started</button>
                        </div>

                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} className="join_the_waitlist">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Title>Ivy is launching soon.</Modal.Title>
                <Modal.Body>
                    <form className="join-modal" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="user-icon" />
                            <input
                                type="text"
                                placeholder="Full Name"
                                className="form-control"
                                onChange={handleChange}
                                name="full_name"
                                value={inquiry.full_name}
                            />
                            {errors.full_name && <p className="text-red-500 text-sm">{errors.full_name}
                            </p>}
                        </div>

                        <div className="form-group">
                            <div className="email-icon" />
                            <input
                                type="email"
                                placeholder="Email address"
                                className="form-control"
                                onChange={handleChange}
                                name="email"
                                value={inquiry.email}
                            />
                            {errors.email && <p className="text-red-500 text-sm">{errors.email}
                            </p>}
                        </div>

                        <div className="form-group">
                            <div className="phone-icon" />
                            <input
                                type="tel"
                                placeholder="Phone Number"
                                className="form-control"
                                onChange={handleChange}
                                name="phone_number"
                                value={inquiry.phone_number}
                            />
                            {errors.phone_number && <p className="text-red-500 text-sm">{errors.phone_number}
                            </p>}
                        </div>
                        {/* <p className="text-head">Are you a solo solicitor or part of a firm?</p> */}

                        {/* <div className="custom-select-wrapper">
                            <select className="custom-select" name="solicitor_type"
                                value={inquiry.solicitor_type}
                                onChange={handleChange}>
                                <option value="solo">Solo</option>
                                <option value="firm">Firm</option>
                            </select>

                        </div> */}

                        <div className="form-group">
                            <input
                                type="text"
                                placeholder="Firm Name"
                                className="form-control firm-name"
                                onChange={handleChange}
                                name="firm_name"
                                value={inquiry.firm_name}
                            />
                            {errors.firm_name && <p className="text-red-500 text-sm">{errors.firm_name}
                            </p>}
                        </div>

                        <p className="text-head">how many users you have in your firm ?</p>
                        <div className="custom-select-wrapper">
                            <select className="custom-select" name="user_count"
                                value={inquiry.user_count}
                                onChange={handleChange}>
                                <option>2-5</option>
                                <option>6-10</option>
                                <option>10+</option>
                            </select>
                        </div>

                        <p className="text-head">Are you currently using any legal software? If yes, which one?</p>
                        <div className="form-group">
                            <input
                                type="text"
                                placeholder="Enter software name"
                                className="form-control firm-name"
                                name="current_software"
                                value={inquiry.current_software}
                                onChange={handleChange}
                            />
                        </div>
                        <p className="text-head">What feature would be a game changer for you in legal software?</p>

                        <textarea
                            placeholder="Feature description here…"
                            className="form-control"
                            name="game_changing_feature"
                            value={inquiry.game_changing_feature}
                            onChange={handleChange}
                        />
                        {errors.game_changing_feature && <span className="text-red-500 text-sm">{errors.game_changing_feature}
                        </span>}
                        <div className="custom-checkbox-block">
                            {/* 
                            <div className="custom-checkbox">
                                <Form.Check aria-label="option 1" name="demo_access_opt_in"
                                    checked={inquiry.demo_access_opt_in}
                                    onChange={handleChange} defaultChecked />
                                <label>Opt in for early demo beta access</label>
                            </div> */}

                            <div className="custom-checkbox">
                                <Form.Check aria-label="option 1" name="refer_colleague"
                                    checked={inquiry.refer_colleague}
                                    onChange={handleChange} />
                                <label>I'd like to refer a colleague</label>
                            </div>
                        </div>

                        {inquiry.refer_colleague && (
                            <div className="form-group">
                                <div className="email-icon" />
                                <input
                                    type="email"
                                    placeholder="Enter your colleague's email"
                                    className="form-control"
                                    name="colleague_email"
                                    value={inquiry.colleague_email}
                                    onChange={handleChange}
                                />
                                {errors.colleague_email && (
                                    <p className="text-red-500 text-sm">{errors.colleague_email}</p>
                                )}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-primary"

                        >
                            Join Waitlist
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
        </>

    );
}

export default Header;